import React from 'react';
import Header from '../../../shared/SiteHeader';
import AboveTheFold from "../../../shared/AboveTheFold";
import Pricing from "../../../shared/Pricing";
import Footer from "../../../shared/MiniCenteredFooter";
import tw from "twin.macro";
import AudienceFit from '../../../shared/AudienceFit';
import DeeperTour from '../../../shared/DeeperTour';

const Container = tw.div`bg-green-500`;

// J-Marketing-27 / S-Marketing-21 (Q-Marketing-51 O-1, revised per
// C-Marketing-224/225, then T-Marketing-225/C-Marketing-237): same progression
// story as the desktop Home — hero + Act 1, the audience-fit matrix band, first
// hour on step 8, evidence, pricing epilogue.
function MobileHome() {
    return (
        <>
            <Header />
            <Container>
                <AboveTheFold isMobile/>
                <div style={{marginTop: '4rem'}}/>
                <AudienceFit isMobile />
                <DeeperTour isMobile />
                <div style={{marginTop: '3rem'}}/>
                <Pricing isMobile heading="" description="" />
            </Container>
            <Footer/>
        </>
    );
}

export default MobileHome;
